module.exports = __webpack_public_path__ + "img/mail.6f0eb009.jpg";